export const getProcessingLegalCompanyFilter = state => state.legalCompany.filter
